__turbopack_context__.v({
  "asterisk": "CustomCodeConsentContent-module-scss-module__zh0qjW__asterisk",
  "layout": "CustomCodeConsentContent-module-scss-module__zh0qjW__layout",
  "listSpacing": "CustomCodeConsentContent-module-scss-module__zh0qjW__listSpacing",
  "mobileLayout": "CustomCodeConsentContent-module-scss-module__zh0qjW__mobileLayout",
});
